/**
 * ReactDOM v15.3.1
 *
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
// Based off https://github.com/ForbesLindesay/umd/blob/master/template.js
;(function(f) {
  // CommonJS
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f(require('react'));

  // RequireJS
  } else if (typeof define === "function" && define.amd) {
    define(['react'], f);

  // <script>
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      // works providing we're not in "use strict";
      // needed for Java 8 Nashorn
      // see https://github.com/facebook/react/issues/3037
      g = this;
    }
    g.ReactDOM = f(g.React);
  }

})(function(React) {
  return React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
});


if (typeof window !== "undefined" && window.hubspot && window.hubspot.define) {
  hubspot.define("react-dom", [], function() { return window["ReactDOM"]; });
  hubspot.define("ReactDOM", [], function() { return window["ReactDOM"]; });
}




//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/node_modules/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!/usr/share/hubspot/build/workspace/MeetingsUI/node_modules/bender-webpack/lib/no-parse-loader.js!/usr/share/hubspot/build/workspace/MeetingsUI/node_modules/@hs/sporks-loader/lib!/usr/share/hubspot/build/.hubspot/static-archive/react-dom/static-6.5/react-dom.js
// module id = 542
// module chunks = 